import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router";
import { OperationsManagementSubheader } from "features/discover/OperationsManagementSubheader";

/**
 * Layout with a defined height and scrollable content area so that percentage-based
 * heights and overflow:auto work correctly in Edge when navigating from another page.
 *
 * The scrollable content div is full width (no maxWidth) so that the Summary table
 * (discover-container--full-width with 100vw) can use the full viewport and show
 * all columns when zooming out. Inner page content can still apply its own max-width.
 */
export function OperationsManagementLayoutPage() {
	const contentRef = useRef<HTMLDivElement>(null);
	const location = useLocation();

	useEffect(() => {
		const el = contentRef.current;
		if (!el) return;
		el.scrollTop = 0;
		const raf = requestAnimationFrame(() => {
			el.scrollTop = 0;
			void el.scrollHeight;
		});
		return () => cancelAnimationFrame(raf);
	}, [location.pathname]);

	return (
		<div
			style={{
				background: "#eee",
				height: "calc(100vh - 80px)",
				display: "flex",
				flexDirection: "column",
				overflow: "hidden",
			}}
		>
			<OperationsManagementSubheader />
			<div
				ref={contentRef}
				style={{
					flex: 1,
					minHeight: 0,
					overflow: "auto",
					width: "100%",
					textAlign: "center",
					fontStyle: "20px",
					paddingBottom: "40px",
				}}
			>
				<Outlet />
			</div>
		</div>
	);
}
